import {
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
  whiteColor,
  blackColor,
} from "../../material-dashboard-react.js";

const cardHeaderStyle = {
  cardHeader: {
    padding: "0.75rem 1.25rem",
    marginBottom: "0",
    borderBottom: "none",
    background: "transparent",
    zIndex: "3 !important",
  },
  cardHeaderPlain: {
    margin: "0 15px",
    padding: "0",
    position: "relative",
    marginLeft: "0px !important",
    marginRight: "0px !important",
  },
  cardHeaderIcon: {
    margin: "0 15px",
    padding: "0",
    position: "relative",
    "& i, & .materialIcons": {
      width: "33px",
      height: "33px",
      textAlign: "center",
      lineHeight: "33px",
    },
    "& svg": {
      width: "24px",
      height: "24px",
      textAlign: "center",
      lineHeight: "33px",
      margin: "5px 4px 0px",
    },
  },
  cardHeaderStats: {
    margin: "0 15px",
    padding: "0",
    position: "relative",
    "& svg": {
      fontSize: "36px",
      lineHeight: "56px",
      textAlign: "center",
      width: "36px",
      height: "36px",
      margin: "10px 10px 4px",
    },
    "& i, & .materialIcons": {
      fontSize: "36px",
      lineHeight: "56px",
      width: "56px",
      height: "56px",
      textAlign: "center",
      overflow: "unset",
      marginBottom: "1px",
    },
    "& .cardHeaderIcon": {
      textAlign: "right",
    },
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      margin: "0 !important",
    },
  },
  warningCardHeader: {
    color: whiteColor,
    "&:not(.cardHeaderIcon)": {
      ...warningCardHeader,
      borderRadius: "3px",
      marginTop: "-20px",
      padding: "15px",
    },
  },
  successCardHeader: {
    color: whiteColor,
    "&:not(.cardHeaderIcon)": {
      ...successCardHeader,
      borderRadius: "3px",
      marginTop: "-20px",
      padding: "15px",
    },
  },
  dangerCardHeader: {
    color: whiteColor,
    "&:not(.cardHeaderIcon)": {
      ...dangerCardHeader,
      borderRadius: "3px",
      marginTop: "-20px",
      padding: "15px",
    },
  },
  infoCardHeader: {
    color: whiteColor,
    "&:not(.cardHeaderIcon)": {
      ...infoCardHeader,
      borderRadius: "3px",
      marginTop: "-20px",
      padding: "15px",
    },
  },
  primaryCardHeader: {
    color: blackColor,
    "&:not(.cardHeaderIcon)": {
      ...primaryCardHeader,
      borderRadius: "3px",
      marginTop: "-20px",
      padding: "15px",
    },
  },
  roseCardHeader: {
    color: whiteColor,
    "&:not(.cardHeaderIcon)": {
      ...roseCardHeader,
      borderRadius: "3px",
      marginTop: "-20px",
      padding: "15px",
    },
  },
};

export default cardHeaderStyle;